registerComponent("sections/capitulos", function (component) {
/**
 * sections/capitulos
 *
 * A entrada na rolagem (ADR 0051): título, parágrafo e a FOTO de cada capítulo
 * entram escalonados — nessa ordem, que é a do documento (ver o ⚠️ do HTML).
 * O mapa e o véu não entram: são o fundo da arte, e fundo que sobe lê como o
 * painel inteiro deslizando.
 *
 * ⚠️ QUEM ENTRA É CADA CAPÍTULO, NÃO O BLOCO DOS SEIS. Acima do degrau
 * `Asa.armarEntrada` observa o que se passa na lista e revela a leva dele de
 * uma vez; com a raiz (3040 de altura em 1440, seis painéis) na lista, os seis
 * painéis entravam juntos assim que o primeiro assomava — as peças numa cascata
 * só, `--ordem` corrido e o teto de 1,3s do atraso. Medido em 1440: com o
 * capítulo 6 ainda a 3046 do alto da tela, as peças dele já tinham `is-in`, e
 * só a entrada do PRIMEIRO capítulo chegava a ser vista. Passando os seis
 * `.capitulo`, cada um é a própria leva e recomeça do 0 quando chega. Abaixo do
 * degrau nada muda: lá o helper já observa peça a peça.
 *
 * ⚠️ NÃO HÁ MAIS CARROSSEL. Até 22/09 o celular punha os seis num trilho
 * horizontal com encaixe e indicadores, e este arquivo os marcava pela posição
 * do trilho; desde o 11117:85972 os capítulos empilham em toda largura e a
 * entrada voltou a ser tudo o que o componente faz em JS.
 *
 * @param {HTMLElement} component - elemento raiz do componente
 * @param {Object} params
 */

Asa.armarEntrada(component.querySelectorAll('.capitulo'), '.entrada');

});
